import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-8 bg-charcoal border-t border-cream/10">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex flex-col md:flex-row justify-between items-center gap-4"
        >
          <div className="flex flex-col items-center md:items-start gap-2">
            <motion.div
              whileHover={{ scale: 1.02 }}
              transition={{ duration: 0.3 }}
            >
              <Logo size="sm" variant="light" showTagline />
            </motion.div>
          </div>

          {/* Tagline & Copyright */}
          <div className="text-center">
            <p className="font-body text-xs uppercase tracking-[0.2em] text-gold-light/60 mb-1">
              Expertise · Integrity · Legacy
            </p>
            <p className="font-body text-sm text-cream/50">
              © {currentYear} Agota Estate. All rights reserved.
            </p>
          </div>

          {/* Legal Links */}
          <div className="flex gap-6">
            <a
              href="#"
              className="font-body text-sm text-cream/50 hover:text-gold-light transition-all duration-300 link-underline"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="font-body text-sm text-cream/50 hover:text-gold-light transition-all duration-300 link-underline"
            >
              Terms
            </a>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};
